import { Request } from "@/utils/request";
import { RequestResult } from "@/utils/requestResult";
import axios from "axios";

export async function getVatPercentage() {
  let vatPercentageResponse = await axios.get(
    window.location.origin + `/rental/api/?action=${Request.GetVatPercentage}`
  ); // mam makeRequest w helpers.js, które w tym scopie nie dziala :(

  switch (vatPercentageResponse.data.error) {
    case RequestResult.OK: {
      return parseInt(
        JSON.parse(vatPercentageResponse.data.data.VALUE).pl.product.Value
      );
    }
  }
  return null;
}
